import { useDispatch } from 'react-redux';
import firebase from 'firebase/app';
import { useEffect } from 'react';

import { identifyAmplitudeUser, loadAmplitude } from '../../../../r/shared/amplitude';
import { validateUserToken, invalidateSession } from '../slices';
import { getActiveReactPage } from '../../../../r/shared/utils';

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  loadAmplitude();
  
  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      const { isProtected, name } = getActiveReactPage();
      
      if (user) {
        if (name === 'SignIn') dispatch(validateUserToken(user));
        identifyAmplitudeUser();
      } else if (isProtected) {
        invalidateSession();
      }
    });

    return unsubscribe;
  }, []);

  return children;
};

export default AuthProvider;